// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes throbber-loader
{
  0%
  {
    background: #dde2e7;
  }
  10%
  {
    background: #6b9dc8;
  }
  40%
  {
    background: #dde2e7;
  }
}

/* :not(:required) hides these rules from IE9 and below */
.throbber-loader:not(:required)
{
  animation:         throbber-loader 2000ms 300ms infinite ease-out;
  background:        #dde2e7;
  display:           inline-block;
  position:          relative;
  text-indent:       -9999px;
  width:             0.9em;
  height:            1.5em;
  margin:            0 1.6em;
}

.throbber-loader:not(:required):before, .throbber-loader:not(:required):after
{
  background: #dde2e7;
  content:    '\\x200B';
  display:    inline-block;
  width:      0.9em;
  height:     1.5em;
  position:   absolute;
  top:        0;
}

.throbber-loader:not(:required):before
{
  animation:         throbber-loader 2000ms 150ms infinite ease-out;
  left:              -1.6em;
}

.throbber-loader:not(:required):after
{
  animation:         throbber-loader 2000ms 450ms infinite ease-out;
  right:             -1.6em;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/spinner/throbber.css"],"names":[],"mappings":"AAgCA;;EAEE;;IAEE,mBAAmB;EACrB;EACA;;IAEE,mBAAmB;EACrB;EACA;;IAEE,mBAAmB;EACrB;AACF;;AAEA,yDAAyD;AACzD;;EAIE,iEAAiE;EACjE,0BAA0B;EAC1B,+BAA+B;EAC/B,2BAA2B;EAC3B,0BAA0B;EAC1B,wBAAwB;EACxB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;;EAEE,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;AACf;;AAEA;;EAIE,iEAAiE;EACjE,yBAAyB;AAC3B;;AAEA;;EAIE,iEAAiE;EACjE,yBAAyB;AAC3B","sourcesContent":["@-moz-keyframes throbber-loader\n{\n  0%\n  {\n    background: #dde2e7;\n  }\n  10%\n  {\n    background: #6b9dc8;\n  }\n  40%\n  {\n    background: #dde2e7;\n  }\n}\n\n@-webkit-keyframes throbber-loader\n{\n  0%\n  {\n    background: #dde2e7;\n  }\n  10%\n  {\n    background: #6b9dc8;\n  }\n  40%\n  {\n    background: #dde2e7;\n  }\n}\n\n@keyframes throbber-loader\n{\n  0%\n  {\n    background: #dde2e7;\n  }\n  10%\n  {\n    background: #6b9dc8;\n  }\n  40%\n  {\n    background: #dde2e7;\n  }\n}\n\n/* :not(:required) hides these rules from IE9 and below */\n.throbber-loader:not(:required)\n{\n  -moz-animation:    throbber-loader 2000ms 300ms infinite ease-out;\n  -webkit-animation: throbber-loader 2000ms 300ms infinite ease-out;\n  animation:         throbber-loader 2000ms 300ms infinite ease-out;\n  background:        #dde2e7;\n  display:           inline-block;\n  position:          relative;\n  text-indent:       -9999px;\n  width:             0.9em;\n  height:            1.5em;\n  margin:            0 1.6em;\n}\n\n.throbber-loader:not(:required):before, .throbber-loader:not(:required):after\n{\n  background: #dde2e7;\n  content:    '\\x200B';\n  display:    inline-block;\n  width:      0.9em;\n  height:     1.5em;\n  position:   absolute;\n  top:        0;\n}\n\n.throbber-loader:not(:required):before\n{\n  -moz-animation:    throbber-loader 2000ms 150ms infinite ease-out;\n  -webkit-animation: throbber-loader 2000ms 150ms infinite ease-out;\n  animation:         throbber-loader 2000ms 150ms infinite ease-out;\n  left:              -1.6em;\n}\n\n.throbber-loader:not(:required):after\n{\n  -moz-animation:    throbber-loader 2000ms 450ms infinite ease-out;\n  -webkit-animation: throbber-loader 2000ms 450ms infinite ease-out;\n  animation:         throbber-loader 2000ms 450ms infinite ease-out;\n  right:             -1.6em;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
